import React, { useMemo } from 'react';
import { Image } from 'semantic-ui-react';
import alstomSavigliano from '../assets/images/alstom-savigliano.jpg';
import alstomDerby from '../assets/images/alstom-derby.jpg';
import alstomBarcellona from '../assets/images/alstom-barcellona.png';
import alstomVadoLigure from '../assets/images/alstom-vado-ligure.png';

export const MapAreaImage: React.VFC = () => {
  const image = useMemo(() => {
    switch (window._env_.REACT_APP_ALSTOM_SITE) {
      case 'DERBY':
        return alstomDerby;
      case 'BARCELLONA':
        return alstomBarcellona;
      case 'VADO_LIGURE':
        return alstomVadoLigure;
      case 'SAVIGLIANO':
      default:
        return alstomSavigliano;
    }
  }, []);

  return <Image style={{ userSelect: 'none' }} draggable="false" src={image} />;
};
